var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletsecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 14H13.25C13.0511 14 12.8603 13.921 12.7197 13.7803C12.579 13.6397 12.5 13.4489 12.5 13.25C12.5 13.0511 12.579 12.8603 12.7197 12.7197C12.8603 12.579 13.0511 12.5 13.25 12.5H26C26.1989 12.5 26.3897 12.421 26.5303 12.2803C26.671 12.1397 26.75 11.9489 26.75 11.75C26.75 11.5511 26.671 11.3603 26.5303 11.2197C26.3897 11.079 26.1989 11 26 11H13.25C12.6533 11 12.081 11.2371 11.659 11.659C11.2371 12.081 11 12.6533 11 13.25V25.25C11 25.8467 11.2371 26.419 11.659 26.841C12.081 27.2629 12.6533 27.5 13.25 27.5H28.25C28.6478 27.5 29.0294 27.342 29.3107 27.0607C29.592 26.7794 29.75 26.3978 29.75 26V15.5C29.75 15.1022 29.592 14.7206 29.3107 14.4393C29.0294 14.158 28.6478 14 28.25 14ZM28.25 26H13.25C13.0511 26 12.8603 25.921 12.7197 25.7803C12.579 25.6397 12.5 25.4489 12.5 25.25V15.3716C12.7408 15.4569 12.9945 15.5004 13.25 15.5H28.25V26ZM23.75 20.375C23.75 20.1525 23.816 19.935 23.9396 19.75C24.0632 19.565 24.2389 19.4208 24.4445 19.3356C24.65 19.2505 24.8762 19.2282 25.0945 19.2716C25.3127 19.315 25.5132 19.4222 25.6705 19.5795C25.8278 19.7368 25.935 19.9373 25.9784 20.1555C26.0218 20.3738 25.9995 20.6 25.9144 20.8055C25.8292 21.0111 25.685 21.1868 25.5 21.3104C25.315 21.434 25.0975 21.5 24.875 21.5C24.5766 21.5 24.2905 21.3815 24.0795 21.1705C23.8685 20.9595 23.75 20.6734 23.75 20.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletsecondary);
export default __webpack_public_path__ + "static/media/walletsecondary.e0546b2cf6f8bb20b127b8b33c7e0688.svg";
export { ForwardRef as ReactComponent };